'use strict';

var _log4js = require('log4js');

var _log4js2 = _interopRequireDefault(_log4js);

var _MinimaConfiguration = require('../MinimaConfiguration');

var _MinimaConfiguration2 = _interopRequireDefault(_MinimaConfiguration);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_log4js2.default.configure(_MinimaConfiguration2.default.log);
var logger = _log4js2.default.getLogger('log');
exports.logger = logger;
//# sourceMappingURL=log.js.map